import { Service } from "./service"

export const PaymentListingService = Service


// WEBPACK FOOTER //
// ./src/state/listing/payment/service/index.ts